import React from 'react';

const sectionStyles = {
  terms: {
    icon: 'bi bi-file-earmark-text',
    bg: 'linear-gradient(90deg,#1769aa 0%,#43e97b 100%)',
    color: '#fff',
    title: 'Terms & Conditions'
  },
  privacy: {
    icon: 'bi bi-shield-lock',
    bg: 'linear-gradient(90deg,#232526 0%,#1769aa 100%)',
    color: '#fff',
    title: 'Privacy Policy'
  },
  policy: {
    icon: 'bi bi-clipboard-check',
    bg: 'linear-gradient(90deg,#43e97b 0%,#232526 100%)',
    color: '#fff',
    title: 'Our Policy'
  }
};

const SectionCard = ({ type, children }) => {
  const style = sectionStyles[type];
  return (
    <div className="mb-5 shadow-lg rounded-4 overflow-hidden" style={{background: '#fff'}}>
      <div className="text-center section-sticky-title" style={{background: style.bg, color: style.color, padding: '28px 0'}}>
        <i className={`${style.icon} mb-2`} style={{fontSize: '2.5rem'}}></i>
        <h2 className="fw-bold mb-0" style={{letterSpacing: '1px'}}>{style.title}</h2>
      </div>
      <div className="p-4 fs-5" style={{minHeight: 120, background: '#f8fafd'}}>
        {children}
      </div>
    </div>
  );
};

const TermPolicy = ({ section }) => (
  <div className="container py-0" style={{maxWidth: 900, overflowY: 'auto', maxHeight: '70vh'}}>
    {(section === 'terms' || !section) && (
      <SectionCard type="terms">
        <b>Terms &amp; Conditions</b><br /><br />
        <b>1. Acceptance of Terms</b><br />
        By accessing or using NeeBun by Red Chilly Computers, you agree to be bound by these Terms &amp; Conditions and all applicable laws and regulations. If you do not agree, please do not use our services.<br /><br />
        <b>2. Use of Services</b><br />
        You agree to use our website and services only for lawful purposes and in a manner that does not infringe the rights of, restrict, or inhibit anyone else’s use and enjoyment.<br /><br />
        <b>3. Intellectual Property</b><br />
        All content, trademarks, logos, and software on this site are the property of NeeBun or its licensors. You may not reproduce, distribute, or create derivative works without explicit permission.<br /><br />
        <b>4. User Content</b><br />
        Any information or content you submit (such as forms or feedback) must be accurate and not violate any laws or third-party rights. We reserve the right to remove any content at our discretion.<br /><br />
        <b>5. Limitation of Liability</b><br />
        NeeBun and Red Chilly Computers are not liable for any direct, indirect, incidental, or consequential damages arising from your use of our website or services.<br /><br />
        <b>6. Third-Party Links</b><br />
        Our website may contain links to third-party sites. We are not responsible for the content or privacy practices of those sites.<br /><br />
        <b>7. Modifications</b><br />
        We reserve the right to update or modify these Terms &amp; Conditions at any time. Changes will be effective immediately upon posting.<br /><br />
        <b>8. Governing Law</b><br />
        These Terms &amp; Conditions are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of the courts in Ferozepur, Punjab.<br /><br />
        <b>9. Contact</b><br />
        For questions regarding these Terms &amp; Conditions, contact us at <a href="mailto:support@ganotras.in">support@ganotras.in</a>.<br /><br />
        <i>Effective Date: May 12, 2026</i>
      </SectionCard>
    )}
    {section === 'privacy' && (
      <SectionCard type="privacy">
        <b>Privacy Policy</b><br /><br />
        <b>1. Introduction</b><br />
        NeeBun by Red Chilly Computers, Ferozepur, is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.<br /><br />
        <b>2. Information We Collect</b><br />
        We may collect personal information that you voluntarily provide to us, including your name, email address, phone number, city, and any other information you choose to provide through forms or communications.<br /><br />
        <b>3. How We Use Your Information</b><br />
        We use your information to:
        <ul>
          <li>Respond to your inquiries and provide customer support</li>
          <li>Improve our website, products, and services</li>
          <li>Send you updates, offers, and relevant communications</li>
          <li>Comply with legal obligations and protect our rights</li>
        </ul>
        <b>4. Sharing Your Information</b><br />
        We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted partners who assist us in operating our website and conducting our business, provided they agree to keep your information confidential.<br /><br />
        <b>5. Data Security</b><br />
        We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.<br /><br />
        <b>6. Cookies & Tracking Technologies</b><br />
        Our website may use cookies and similar technologies to enhance your experience and analyze usage. You can choose to disable cookies through your browser settings.<br /><br />
        <b>7. Your Rights</b><br />
        You have the right to access, correct, or delete your personal information. You may also opt out of receiving communications from us at any time.<br /><br />
        <b>8. Changes to This Policy</b><br />
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.<br /><br />
        <b>9. Contact Us</b><br />
        If you have any questions or concerns about this Privacy Policy or our practices, please contact us at <a href="mailto:support@ganotras.in">support@ganotras.in</a>.<br /><br />
        <i>Effective Date: May 12, 2026</i>
      </SectionCard>
    )}
    {section === 'policy' && (
      <SectionCard type="policy">
        At NeeBun (Red chilly Computers), Ferozepur, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner.<br /><br />
        <hr />
        <b>1. Information We Collect</b><br />
        When you interact with our website or social media advertisements (such as Facebook/Instagram lead forms), we may collect:<br />
        &bull; Name<br />
        &bull; Phone Number<br />
        &bull; Email Address (if provided)<br />
        &bull; City (if needed)<br />
        <hr />
        <b>2. How We Use Your Information</b><br />
        Your information is used only for:<br />
        &bull; Responding to your queries<br />
        &bull; Providing resolution of your query/information<br />
        &bull; Sharing relevant updates, offers<br />
        <hr />
        <b>3. Data Sharing &amp; Security</b><br />
        &bull; We do not sell, rent, or trade your personal information to third parties.<br />
        &bull; Your data is securely stored and accessed only by authorized staff.<br />
        &bull; We may use trusted third-party platforms (like Meta/Facebook, Google) for ad and communication purposes, in compliance with their policies.<br />
        <hr />
        <b>4. Consent</b><br />
        By submitting your details through our website or ads, you:<br />
        &bull; Consent to be contacted via call, SMS, or WhatsApp<br />
        &bull; Agree to receive information regarding our services and appointments<br />
        <hr />
        <b>5. Data Protection</b><br />
        We take appropriate measures to protect your personal data from unauthorized access, misuse, or disclosure.<br />
        <hr />
        <b>6. Your Rights</b><br />
        You have the right to:<br />
        &bull; Request access to your data<br />
        &bull; Ask for correction or deletion of your data<br />
        &bull; Opt-out of communications at any time<br />
         If you have any questions or concerns about this Privacy Policy or our practices, please contact us at <a href="mailto:support@ganotras.in">support@ganotras.in</a>.<br /><br />
        <i>Effective Date: May 12, 2026</i>
      </SectionCard>
    )}
  </div>
);

// Add sticky CSS globally
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = `.section-sticky-title { position: sticky; top: 0; z-index: 10; }`;
  document.head.appendChild(style);
}

export default TermPolicy;
